import { environment } from "src/environments/environment.development";
export class AppConfiguration {
    // API URLs
    public static BASE_URL = environment.base_url;
   // public static SECURED = AppConfiguration.BASE_URL + 'secured/qrsp30-api';
   // public static COMMONS = AppConfiguration.BASE_URL + 'qrsp30-api/commons';
     public static SECURED = AppConfiguration.BASE_URL + '/qrsp/secured/qrsp30-api';
     public static COMMONS = AppConfiguration.BASE_URL + '/qrsp/qrsp30-api/commons';
}
